import { APIMethod, fetchData } from "@client";

export async function removeCompanyPresetQuery(presetId) {
  await fetchData(`/preset/${presetId}`, APIMethod.DELETE);
}
